import { StreamType } from "../../interface";

export const ROOM_STAGE_VIDEO_MEDIA_STREAM_TYPE: StreamType[] = [
  "localVideoFile",
  "screen"
];
